function isEmpty(value) {
  return value === "" || value === null || value === undefined;
}

function validatePositiveInteger(value, fieldName) {
  if (isEmpty(value) || Number.isNaN(Number(value))) {
    return `${fieldName} es obligatorio.`;
  }

  if (!Number.isInteger(Number(value)) || Number(value) <= 0) {
    return `${fieldName} debe ser un entero positivo.`;
  }

  return null;
}

export function validateClientCityToCityPayload({
  origin_id,
  destination_id,
  price,
  priceKm,
}) {
  const originError = validatePositiveInteger(origin_id, "El origen");
  if (originError) {
    return originError;
  }

  const destinationError = validatePositiveInteger(
    destination_id,
    "El destino",
  );
  if (destinationError) {
    return destinationError;
  }

  if (isEmpty(price)) {
    return "El precio es obligatorio.";
  }

  if (Number.isNaN(Number(price))) {
    return "El precio debe ser un numero decimal valido.";
  }

  if (Number(price) < 0) {
    return "El precio no puede ser negativo.";
  }

  if (isEmpty(priceKm)) {
    return "El precio por kilometro es obligatorio.";
  }

  if (Number.isNaN(Number(priceKm))) {
    return "El precio por kilometro debe ser un numero decimal valido.";
  }

  if (Number(priceKm) < 0) {
    return "El precio por kilometro no puede ser negativo.";
  }

  return null;
}
